export default "__VITE_PUBLIC_ASSET__7f209f5a__"